// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 768px)";
var _3 = "monthWrapper-3LIec";
var _4 = "month-_bu6J";
var _5 = "week-2avQa";
var _6 = "week_withPrice-3h2Vs";
export { _1 as "__esModule", _2 as "tabletMiddle", _3 as "monthWrapper", _4 as "month", _5 as "week", _6 as "week_withPrice" }
export default { "__esModule": _1, "tabletMiddle": _2, "monthWrapper": _3, "month": _4, "week": _5, "week_withPrice": _6 }
